const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy/marvy_mono/apps/pinktool/src/routes/_app/balance-logs.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/balance-logs")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type BalanceLogData = {
  type: "idea_submit" | "idea_revert_submission" | "topup";
  actor: string;
  idea_id: number;
  board_id: number;
  idea_title: string;
  total_bee: number;
  rank_price: number;
  rank_name: string;
};